import React, { useState, useEffect } from 'react';
import { 
  FaTimes, FaPaperPlane, FaCheck, FaUser, 
  FaEnvelope, FaPhone, FaComment, FaShieldAlt, 
  FaGraduationCap, FaBookOpen,
  FaWhatsapp
} from 'react-icons/fa';
import { MdVerified, MdLocationOn } from 'react-icons/md';

const EnquiryPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    course: '',
    qualification: '',
    message: '',
    agreeTerms: false,
    receiveUpdates: false
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('College Enquiry Form submitted:', formData);
    setIsSubmitted(true);

    setTimeout(() => {
      setIsSubmitted(false);
      setIsOpen(false);
      document.body.style.overflow = 'auto';
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        course: '',
        qualification: '',
        message: '',
        agreeTerms: false,
        receiveUpdates: false
      });
    }, 2000);
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-sm animate-slideUp">
        
        {/* Decorative Border Top */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-t-lg"></div>
        
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white px-3 py-2 rounded-t-lg">
          <div className="flex justify-between items-center">
            <div>
              <div className="flex items-center gap-1.5">
                <FaGraduationCap className="text-yellow-300 text-xs" />
                <h2 className="text-sm font-bold">BNS Mahila Maha Vidyalaya</h2>
              </div>
              <p className="text-[10px] text-blue-200">Admission Enquiry</p>
            </div>
            <button 
              onClick={handleClose}
              className="hover:bg-white/20 p-0.5 rounded-full transition-colors"
            >
              <FaTimes className="text-white text-xs" />
            </button>
          </div>
        </div>

        {/* College Info Bar */}
        <div className="bg-blue-50 px-3 py-1 border-b border-blue-100">
          <div className="flex items-center justify-center gap-2 text-[10px] text-blue-700">
            <div className="flex items-center gap-0.5">
              <MdLocationOn className="text-blue-500 text-[10px]" />
              <span>Akhari Bai-Pass, Varanasi</span>
            </div>
            <div className="flex items-center gap-0.5">
              <FaWhatsapp className="text-green-500 text-[10px]" />
              <span>7080100324</span>
            </div>
          </div>
        </div>

        {/* Success Message */}
        {isSubmitted && (
          <div className="m-2 bg-green-50 border border-green-200 rounded-md p-1.5 flex items-center gap-1.5">
            <div className="bg-gradient-to-r from-green-500 to-emerald-500 rounded-full p-0.5">
              <FaCheck className="text-white text-[8px]" />
            </div>
            <p className="text-[10px] font-semibold text-green-800">Enquiry Sent Successfully!</p>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-3 space-y-2">
          {/* Full Name */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Full Name <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FaUser className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[10px]" />
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20"
                placeholder="Enter full name"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Email <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FaEnvelope className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[10px]" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20"
                placeholder="your@email.com"
              />
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Phone <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FaPhone className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[10px]" />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20"
                placeholder="9876543210"
              />
            </div>
          </div>

          {/* Course */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Course <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FaBookOpen className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[10px]" />
              <select
                name="course"
                value={formData.course}
                onChange={handleChange}
                required
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20 bg-white"
              >
                <option value="">Select course</option>
                <option value="ba">B.A.</option>
                <option value="bcom">B.Com</option>
                <option value="bsc">B.Sc.</option>
                <option value="ma">M.A.</option>
                <option value="msc">M.Sc.</option>
              </select>
            </div>
          </div>

          {/* Qualification */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Qualification <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <FaGraduationCap className="absolute left-2 top-1/2 -translate-y-1/2 text-blue-400 text-[10px]" />
              <select
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
                required
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20 bg-white"
              >
                <option value="">Select</option>
                <option value="10th">10th Pass</option>
                <option value="12th">12th Pass</option>
                <option value="graduate">Graduate</option>
              </select>
            </div>
          </div>

          {/* Message */}
          <div>
            <label className="block text-gray-700 font-medium text-[10px] mb-0.5">
              Message
            </label>
            <div className="relative">
              <FaComment className="absolute left-2 top-1.5 text-blue-400 text-[10px]" />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="2"
                className="w-full pl-7 pr-2 py-1 text-xs border border-gray-300 rounded-md focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-400/20 resize-none"
                placeholder="Your message..."
              ></textarea>
            </div>
          </div>

          {/* Checkboxes - Full Text */}
          <div className="space-y-1.5 pt-1">
            <label className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="agreeTerms"
                checked={formData.agreeTerms}
                onChange={handleChange}
                required
                className="mt-0.5 w-3 h-3 text-blue-600 focus:ring-blue-400 border-gray-300 rounded shrink-0"
              />
              <span className="text-[10px] text-gray-700 leading-relaxed">
                I agree to the <a href="/terms-conditions" className="text-blue-600 hover:underline font-medium">Terms & Conditions</a> and <a href="/privacy-policy" className="text-blue-600 hover:underline font-medium">Privacy Policy</a>
              </span>
            </label>
            
            <label className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="receiveUpdates"
                checked={formData.receiveUpdates}
                onChange={handleChange}
                className="mt-0.5 w-3 h-3 text-blue-600 focus:ring-blue-400 border-gray-300 rounded shrink-0"
              />
              <span className="text-[10px] text-gray-600 leading-relaxed">
                I would like to receive updates from BNS Mahila Maha Vidyalaya via Email, SMS, and WhatsApp
              </span>
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-semibold py-1.5 rounded-md transition-all duration-300 flex items-center justify-center gap-1.5 text-xs mt-2"
          >
            <FaPaperPlane className="text-white text-[10px]" />
            SEND ENQUIRY
          </button>

          {/* Trust Badge */}
          <div className="text-center pt-0.5">
            <div className="flex items-center justify-center gap-1">
              <FaShieldAlt className="text-gray-400 text-[8px]" />
              <p className="text-[8px] text-gray-400">Your information is safe with us</p>
              <MdVerified className="text-blue-500 text-[8px]" />
            </div>
          </div>
        </form>

        {/* Bottom Border */}
        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 rounded-b-lg"></div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default EnquiryPopup;